@if (isOpen) {
    <div
        #dropdownRef
        class="absolute z-40 right-0 w-[240px] rounded-xl border border-gray-200 bg-white shadow-theme-lg dark:border-gray-800 dark:bg-gray-dark"
        [ngClass]="(placement === 'up' ? 'bottom-full mb-2' : 'top-full mt-2') + ' ' + className"
    >
        <!-- Arrow indicator -->
        @if (showArrow) {
            <div
                    class="absolute w-3 h-3 bg-white border-t border-r border-gray-200 dark:bg-gray-dark dark:border-gray-800 rotate-45"
                    [ngClass]="placement === 'up' ? 'bottom-[-7px] right-4' : 'top-[-7px] right-4'"
                    aria-hidden="true"
            ></div>
        }
        <ng-content></ng-content>
    </div>
}
